import { useContext, useEffect, useState } from "react";
import { BsPencil } from "react-icons/bs";
import { Link, useNavigate } from "react-router-dom";
import { listContext } from "../../Pages/assessment/ListContext";
import { IconButton, Tooltip, useDisclosure, useToast } from "@chakra-ui/react";
import { FaEye } from "react-icons/fa";
import { MdOutlineDeleteForever } from "react-icons/md";
import { getLeadName } from "../../Config/leadStatus";
import { convert12HourFormat, getDateFormat } from "../../Config/functions";
import { PersonalInfo } from "../Tooltip/PersonalInfo";
import { DeleteModal } from "../Modals/DeleteaAssessmentModal";
import { IoMdSend } from "react-icons/io";
import { Col, Button, Row, Form } from "react-bootstrap";
import { CheckIcon, CopyIcon, EditIcon } from "@chakra-ui/icons";
import AssessmentDataService from "../../services/Assessment";
import { IoLink } from "react-icons/io5";

export const SingleRowAssessment = ({ props, func, func1 }: any) => {
  const navigate = useNavigate();
  const { isOpen, onOpen, onClose } = useDisclosure();
  const token = localStorage.getItem("logged_in_user_token");
  const accessControls =
    JSON.parse(localStorage.getItem("logged_in_user_accesscontrols") || "[]") ||
    [];
  const toast = useToast();
  const [copied, setCopied] = useState(false);

  const { id, data, status, source } = props;
  const [leadStatus, setLeadStatus] = useState(data.new_lead_status);
  const [modal, setModal] = useState("");
  const [markedStatusEditable, setMarkedStatusEditable] = useState(false);
  const [markedStatus, setMarkedStatus] = useState(data.marked_as);

  const { isallChecked } = useContext(listContext);
  const [isChecked, setIsChecked] = useState(isallChecked);

  const handleCopy = (email: string = "") => {
    if (false) {
      // Modern method (only works over HTTPS or localhost)
      navigator.clipboard
        .writeText(email)
        .then(() => {
          onCopySuccess();
        })
        .catch(() => {
          onCopyFail();
        });
    } else {
      // Fallback for HTTP or unsupported clipboard API
      const textArea = document.createElement("textarea");
      textArea.value = email;
      textArea.style.position = "fixed";
      textArea.style.opacity = "0";

      document.body.appendChild(textArea);
      textArea.focus();
      textArea.select();

      try {
        const successful = document.execCommand("copy");
        if (successful) {
          onCopySuccess();
        } else {
          onCopyFail();
        }
      } catch (err) {
        onCopyFail();
      }

      document.body.removeChild(textArea);
    }
  };

  const onCopySuccess = () => {
    setCopied(true);
    toast({
      title: "Email copied.",
      status: "success",
      duration: 2000,
      position: "top",
      isClosable: true,
    });
    setTimeout(() => setCopied(false), 1500);
  };

  const onCopyFail = () => {
    toast({
      title: "Copy failed.",
      status: "error",
      duration: 2000,
      position: "top",
      isClosable: true,
    });
  };

  const handleMarkedStatus = (event: any) => {
    event.preventDefault();
    setMarkedStatus(markedStatus);

    AssessmentDataService.updateMarkStatus(markedStatus, id, token)
      .then((res: any) => {
        setMarkedStatusEditable(false);
        toast({
          position: "top",
          title: "Marked As Status Saved Successfully",
          status: "success",
          duration: 1500,
          isClosable: true,
        });
      })
      .catch((e) => {
        toast({
          position: "top",
          title: "Marked As Status Save Failed",
          status: "error",
          duration: 1500,
          isClosable: true,
        });
      });
  };

  useEffect(() => {
    setIsChecked(isallChecked);
    func1(id, isallChecked, props);
  }, [isallChecked]);

  return (
    <tr
      style={{
        backgroundColor:
          markedStatus === "urgent"
            ? "#fee2e2"
            : markedStatus === "followup"
            ? "#fef9c3"
            : "transparent",
      }}
    >
      {!accessControls.includes("juniorEhcExpert") && (
        <td>
          {/* <div className="edit-icon"> */}
          <input
            type="checkbox"
            aria-label="Checkbox"
            checked={isChecked}
            onChange={(e) => {
              func1(id, e.target.checked, props);
              setIsChecked(e.target.checked);
            }}
          />
          {/* </div> */}
        </td>
      )}
      <td>
        <div className="edit-icon">
          <BsPencil
            onClick={() => {
              localStorage.setItem("ehc_page", "new");
              navigate(`/freeconsultation/edit/${id}`);
            }}
          />
        </div>
      </td>
      <td>
        <Row>
          <Col xs={7}>
            <Form.Select
              value={markedStatus}
              onChange={(e) => setMarkedStatus(e.target.value)}
              disabled={!markedStatusEditable}
              style={{
                width: "110px",
                zIndex: "2",
                backgroundColor: "transparent",
                color: "black",
              }}
              className="custom-select"
            >
              <option value="" style={{ color: "black" }}>
                Select
              </option>
              <option value="urgent" style={{ color: "red" }}>
                Urgent
              </option>
              <option value="followup" style={{ color: "orange" }}>
                FollowUp
              </option>
            </Form.Select>
          </Col>
          <Col xs={3}>
            {markedStatusEditable ? (
              <Button className="sheet_btn" onClick={handleMarkedStatus}>
                <CheckIcon />
              </Button>
            ) : (
              <Button
                className=" sheet_btn"
                onClick={() => setMarkedStatusEditable(true)}
              >
                <EditIcon />
              </Button>
            )}
          </Col>
        </Row>
      </td>
      <td>
        {/* getDateFormat(data.date) */}
        {data.date && data.date != "" ? getDateFormat(data.date) : ""}-{" "}
        {data.time && data.time != "" ? convert12HourFormat(data.time) : ""}
      </td>
      <td>
        {data.expert
          ? data.expert.split("_")[2]
            ? data.expert.split("_")[2]?.charAt(0).toUpperCase() +
              data.expert.split("_")[2]?.slice(1)
            : data.expert.split("_")[1]?.charAt(0).toUpperCase() +
              data.expert.split("_")[1]?.slice(1)
          : "Not Assigned"}
      </td>
      <Tooltip
        label={<PersonalInfo {...data.client_information} />}
        placement="bottom-start"
      >
        <td>
          <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
            <p className="client_email" style={{ margin: 0 }}>
              {data.client_information.name}
            </p>
            <Tooltip label="Copy Email" hasArrow>
              <IconButton
                icon={<CopyIcon />}
                size="xs"
                variant="outline"
                colorScheme="yellow"
                aria-label="Copy email"
                onClick={() => {
                  handleCopy(data.client_information.email);
                }}
              />
            </Tooltip>
          </div>
        </td>
      </Tooltip>
      {/* <td>{data.lead_owner}</td> */}
      <td>{data.lead_origin}</td>
      <Tooltip
        label={data.screening_information.issues.join(", ")}
        placement="bottom-start"
      >
        <td className="client_email">
          {data.screening_information.issues &&
          data.screening_information.issues.length > 0
            ? data.screening_information.issues.join(", ")
            : ""}
        </td>
      </Tooltip>
      <td>{leadStatus && leadStatus !== "" ? getLeadName(leadStatus) : ""}</td>
      <td>
        {" "}
        <div className="d-flex align-items-center">
          <Tooltip label="link to crm" hasArrow>
            <a
              href={`https://dolphin.manoshala.com/dashboard?useremail=${data.client_information.email}&source=${source}&status=${status}`}
              target="_blank"
              rel="noopener noreferrer"
            >
              <IoLink />
            </a>
          </Tooltip>
          <Link to={`/freeconsultation/view/${id}`}>
            <button
              type="button"
              className="btn"
              onClick={() => {
                localStorage.setItem("ehc_page", "new");
              }}
            >
              <FaEye style={{ color: "#f48a0f" }} />
            </button>
          </Link>
          <MdOutlineDeleteForever
            className="deleteButton pointer"
            onClick={() => {
              setModal("deletemodal");
              onOpen();
            }}
          />
        </div>
        {modal === "deletemodal" && (
          <DeleteModal isOpen={isOpen} onClose={onClose} func={func} id={id} />
        )}
      </td>
    </tr>
  );
};
